module.exports = __webpack_public_path__ + "dash_20_app_assets/img/smiley.f458c7ee.png";